<!--  -->
<template>
<cc-container class="skeketon" style="height:100%; overflow:hidden">
 <cc-main style="overflow:hidden" >
   <div class="head">
    <div class="skeketon-center-content"></div>
    </div>
    <ul>
      <li class="skeketon-item" v-for="i in 4" :key="i">
      <div class="skeketon-item-center">
        <div class="skeketon-item-center-left">
          <span></span>
        </div>
        <div class="skeketon-item-center-center">
          <div class="w221 h15"></div>
          <div class="w221 h15 two"></div>
          <div class="skeketon-price">
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
      <div class="skeketon-item-bottom">
        <div class="skeketon-item-bottom-right w221"></div>
      </div>
      </li>
    </ul>
    </cc-main>
  </cc-container>
</template>

<script>
export default {
  components: {},

  data () {
    return {
    }
  },

  computed: {},

  created () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
.skeketon{
  @include skeletonBlink();
  .head{
    height: 45px;
    width: 100%;
    background: var(--APP_skeleton_color);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/{
   .cc-header{
    background: var(--APP_skeleton_color);;
  }
  .cc-main{
   overflow: hidden !important;
  }
  }
  &-left-content,&-center-content,&-right-content{
    width: 18px;
    height: 18px;
    border-radius: 3px;
    background: var(--APP_skeleton_color);
  }
  &-center-content{
    height: 30px;
    width: 300px;
    background: #fff;
    opacity: .5;
  }
  &-item{
   width: 355px;
   margin: 10px auto;
    // height: 174px;
    padding: 10px;
    border-radius: 10px;
    background: var(--APP_skeleton_background_color);
    box-sizing: border-box;
    margin-bottom: 8px;
    &-center{
      width: 100%;
      height: 60px;
      padding: 12px 0;
      overflow: hidden;
      &-left{
        height: 64px;
        float: left;
        >span{
          display: inline-block;
          height: 89px;
          width:89px;
          margin-right: 25px;
          background:  var(--APP_skeleton_color);
        }
      }
      &-center{
        float: left;
        >div{
         background:  var(--APP_skeleton_color);
         border-radius: 3px;
        }
       .skeketon-price{
          background: #fff;
          span{
            display: inline-block;
            width: 75px;
            height: 15px;
            background: var(--APP_skeleton_color);
            margin-right: 10px;
            border-radius: 3px;
          }
        }
        .two{
          margin: 10px 0;
        }
      }
    }

    &-bottom{
      width: 100%;
      height: 53px;
      margin-top: 10px;
      position: relative;
      &-right{
        height: 15px;
        background: var(--APP_skeleton_color);
        position: absolute;
        right: 0;
        bottom: 10px;
        border-radius: 3px;
      }
      &-bottom{
        >div{
          float: right;
          margin-top: 30px;
          width: 65px;
          height: 15px;
          background: var(--APP_skeleton_color);
          border-radius:3px;
        }
      }
    }
  }

}

</style>
